import { Injectable } from '@angular/core';
import { Scheduler } from 'rxjs';
import { throttleTime } from 'rxjs/operators';

import { RailingLightArrangeService } from './railing-light-arrange.service';
import { RailLightAppendService } from './rail-light-append.service';
import { StageService } from '../../stage.service';
import { RailingLightmapService } from '../../lightMap/railing-lightmap.service';
import { RailingGenerationService } from '../services/railing-generation.service';
import { ILightFlags } from '../../lightMap/types';

@Injectable()
export class RailingLightService {
  private _postLight = false;
  private _topRailLight = false;
  private _bottomRailLight = false;
  private _hasRailing: boolean;

  constructor(
    private lightArrange: RailingLightArrangeService,
    private stage: StageService,
    private railingLightmapSrvc: RailingLightmapService,
    private railingGenerationSrvc: RailingGenerationService,
    private railLightAppendService: RailLightAppendService
  ) {
    this._hasRailing = railingGenerationSrvc.isVisible;
    const railState = railingGenerationSrvc.onRailStateChanged.pipe(
      throttleTime(1000, Scheduler.async, {
        leading: true,
        trailing: true
      })
    );
    railState.subscribe(show => {
      this._hasRailing = show;
      this.railingLightmapSrvc.forAll(this.getFlags());
    });
    railLightAppendService.onAdded.subscribe(added => {
      const { lightMesh, verticalPosition } = added;
      lightMesh.visible = verticalPosition === 'Top' ? this._topRailLight : this._bottomRailLight;
    });
  }

  get postLight(): boolean {
    return this._postLight;
  }

  get topRailLight(): boolean {
    return this._topRailLight;
  }

  get bottomRailLight(): boolean {
    return this._bottomRailLight;
  }

  private getFlags(): ILightFlags {
    if (!this._hasRailing) {
      return {
        top: false,
        bottom: false,
        post: false
      };
    } else {
      return {
        top: this._topRailLight,
        bottom: this._bottomRailLight,
        post: this._postLight
      };
    }
  }

  switchPostLighting(turnOn: boolean) {
    this._postLight = turnOn;
    this.railingLightmapSrvc.forAll(this.getFlags());
    this.switchPostLightMesh(turnOn);
  }

  private switchPostLightMesh(turnOn: boolean) {
    this.stage.scene.traverse(
      obj => (obj.visible = obj.name === 'PostAccentLight' ? turnOn : obj.visible)
    );
  }

  private switchRailLightMesh(turnOn: boolean, railName: string) {
    this.stage.scene.traverse(obj => {
      if (obj.name === railName) {
        obj.children.forEach(ch => (ch.visible = ch.name === 'railLight' ? turnOn : ch.visible));
      }
    });
  }

  switchTopRailLighting(turnOn: boolean) {
    this._topRailLight = turnOn;
    this.railingLightmapSrvc.forAll(this.getFlags());
    this.switchRailLightMesh(turnOn, 'HandrailContainer');
  }

  switchBottomRailLighting(turnOn: boolean) {
    this._bottomRailLight = turnOn;
    this.railingLightmapSrvc.forAll(this.getFlags());
    this.switchRailLightMesh(turnOn, 'BaseRailContainer');
  }
}



// WEBPACK FOOTER //
// ./src/app/services/railing/light/railing-light.service.ts